export default __webpack_public_path__ + "static/media/leaders-icon-active.cec1b82f.svg";